import { HttpErrorResponse } from '@angular/common/http';
import e from 'express';

/* 
 * Use to pase error message, such as following structure from proxy
*/
export function parseHttpErrorMessage(error: HttpErrorResponse, fallback = 'Unknown error'): string {
  // Resolve the raw message string from whichever layer has it
  let rawMessage = '';
  if (error?.error?.message) {
    rawMessage = error.error.message;
  } else if (typeof error?.error === 'string') {
    try {
      rawMessage = JSON.parse(error.error)?.message || error.error;
    } catch {
      rawMessage = error?.message || '';
    }
  } else {
    rawMessage = error?.message || '';
  }

  // Angular embeds the response body inside its own error message string and this error is most from developer portal proxy
  // e.g. error.mesage: `500 on GET request for "url": "{...\"message\":\"real message\"...}"`
  // Extract the embedded JSON and return its message field if present.
  const jsonStart = rawMessage.lastIndexOf('{');
  const jsonEnd = rawMessage.indexOf('}');
  if (jsonStart !== -1 && jsonEnd > jsonStart) {
    try {
      const removedEscapedStr = rawMessage.substring(jsonStart, jsonEnd + 1).replaceAll(String.raw`\"`, '"');
      const parsed = JSON.parse(removedEscapedStr);
      if (parsed?.message) return parsed.message;
    } catch(error){
      console.error('parse error filed: ', error);
    }
  }
  return rawMessage || fallback;
}
